module.exports = __webpack_public_path__ + "img/UZ.b20f1adb.svg";